import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {StructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import BaseDetailTransferStructuredTableAdapter, {
  BaseDetailStructuredTableRowMetadata,
} from 'samples/plate-maps/transfer-table/BaseDetailTransferStructuredTableAdapter';
import {BaseFillPlateTransferStructuredTableMetadata} from 'samples/plate-maps/transfer-table/BaseFillPlateTransferStructuredTableAdapter';

export type WellViewStructuredTable = StructuredTable<
  BaseFillPlateTransferStructuredTableMetadata,
  BaseDetailStructuredTableRowMetadata
>;

/**
 * Adapter describing and constraining the behavior of the Well View Transfer Table in the Fill Plate modal.
 *
 * This table is never embedded in Notebook and never persisted. Its content is determined by a combination of
 * preexisting values of Inventory items and user selections made in the Fill Plate modal.
 */
export default class WellViewStructuredTableAdapter extends BaseDetailTransferStructuredTableAdapter<BaseFillPlateTransferStructuredTableMetadata> {
  static getAdapter(): WellViewStructuredTableAdapter {
    return getStructuredTableAdapters().FILL_PLATE_TRANSFER_WELL_VIEW as WellViewStructuredTableAdapter;
  }
}
